let currentCounter = 0;

export default function(prefix = '') {
  currentCounter += 1;
  return prefix + "id-" + currentCounter;
}
